import { Injectable } from '@angular/core';

import { RepositoryService } from '@_services/api/repository.service';
import { GeneratedCampaignMediaApiService } from './campaign-media-api-generated.service';

@Injectable({
  providedIn: 'root'
})
export class CampaignMediaApiService extends GeneratedCampaignMediaApiService {
  constructor(repo: RepositoryService) {
    super(repo);
  }
}
